<ng-container *ngIf="TaskTypes.indexOf(node.type)>-1">
    <tam-diagram-textbox-node [nodeId]="node.guid" [branchId]="branchId">
    </tam-diagram-textbox-node>
</ng-container>
<ng-container *ngIf="isGatewayNode()">
    <tam-diagram-branch-node [nodeId]="node.guid"></tam-diagram-branch-node>
</ng-container>